import { render, staticRenderFns } from "./TrCanvas.vue?vue&type=template&id=02fc3087&scoped=true&"
import script from "./TrCanvas.vue?vue&type=script&lang=js&"
export * from "./TrCanvas.vue?vue&type=script&lang=js&"
import style0 from "./TrCanvas.vue?vue&type=style&index=0&id=02fc3087&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02fc3087",
  null
  
)

export default component.exports